import styled from 'styled-components';

export const CarouselCard = styled.div`
  margin-right: 0px;
  min-width: 100%;
  overflow: hidden;
`;
